var rich_content_viewer_default = {
  "fontElementMap": "Z2ck1",
  "wrapper": "pPWaf",
  "pluginContainerMobile": "gK8lW",
  "viewer": "hbmah",
  "android": "KWaIk",
  "rootedTraversedContent": "Mww9N",
  "atomic": "_1PldE",
  "toolbar": "WWxhm",
  "block": "cw7IV"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
